import styled from 'styled-components';

export const Container = styled.header`
  display: flex;

  background: #93c051;

  padding: 0 30px;
  height: 88px;

  h1 {
    padding-top: 1.2rem;
    font-size: 40px;
    font-weight: 600;
    margin: 0 auto;
    color: rgb(255 255 255);
    justify-content: center;
  }

  @media screen and (max-width: 630px) {
    height: 80px;
    h1 {
      font-size: 30px;
    }
  }
  @media screen and (max-width: 490px) {
    height: 70px;
    h1 {
      font-size: 20px;
    }
  }
  @media screen and (max-width: 350px) {
    height: 60px;
    h1 {
      font-size: 15px;
    }
  }
`;
